import React from 'react';
import Info from '../Symbols/Info';
import Row from '../Symbols/Row';
import Button from '../Symbols/Button';
import Result from './Result';
import Form from '../Symbols/Form';
import InputSelect from '../Symbols/InputSelect';
import Input from '../Symbols/Input';
import InputCurrency from '../Symbols/InputCurrency';
import { YesNoOptions } from '../common/YesNoOptions';
import Wrapper from '../Symbols/Wrapper';
import { YEARS_CHILD_ALLOWANCE } from '../LegalParameters/Constants';

const emptyFunc = () => {};

const years = YEARS_CHILD_ALLOWANCE.map(year => ({ name: year, value: year }));

export default props => {
	const {
		validateHandler = emptyFunc,
		changeHandler = emptyFunc,
		errors = {},
		state: { adult, children6, children15, children26, income, allowance, year },
		result = null,
		onSubmit,
		reset,
	} = props;

	return (
		<Wrapper>
			<Form onSubmit={onSubmit} title="Kalkulačka – Přídavky na dítě">
				<InputSelect
					label="Výpočet pro rok:"
					name="years"
					value={year}
					onChange={changeHandler('year')}
					onBlur={validateHandler('year')}
					passedProps={{ 'data-cy': 'year' }}
					select={years}
					error={errors.year}
				/>

				<Input
					label="Počet dospělých osob"
					name="adult"
					value={adult}
					type="adult"
					onChange={changeHandler('adult')}
					onBlur={validateHandler('adult')}
					passedProps={{ min: 1, step: 1, 'data-cy': 'adult' }}
					error={errors.adult}
				/>

				<Input
					label="Počet dětí do 6 roků"
					name="children6"
					value={children6}
					type="number"
					onChange={changeHandler('children6')}
					onBlur={validateHandler('children6')}
					passedProps={{ min: 0, step: 1, 'data-cy': 'children6' }}
					error={errors.children6}
				/>

				<Input
					label="Počet dětí 6 – 15 roků"
					name="children15"
					value={children15}
					type="number"
					onChange={changeHandler('children15')}
					onBlur={validateHandler('children15')}
					passedProps={{ min: 0, step: 1, 'data-cy': 'children15' }}
					error={errors.children15}
				/>

				<Input
					label="Počet dětí ve věku od 15 do 26 let (studující)"
					name="children26"
					value={children26}
					type="number"
					onChange={changeHandler('children26')}
					onBlur={validateHandler('children26')}
					passedProps={{ min: 0, step: 1, 'data-cy': 'children26' }}
					error={errors.children26}
				/>

				<InputCurrency
					label={
						<>
							Průměrný měsíční příjem (rodiny) <sup>1</sup>
						</>
					}
					name="income"
					value={income}
					onChange={changeHandler('income')}
					onBlur={validateHandler('income')}
					passedProps={{ min: 0, step: 1, 'data-cy': 'income' }}
					error={errors.income}
				/>

				<InputSelect
					label={
						<>
							Nárok na zvýšené přídavky podle zákona 117/1995, § 18? <sup>2</sup>
						</>
					}
					name="allowance"
					value={allowance}
					onChange={changeHandler('allowance')}
					onBlur={validateHandler('allowance')}
					passedProps={{ 'data-cy': 'allowance' }}
					select={YesNoOptions}
					error={errors.allowance}
				/>

				<div css={Row}>
					<Button data-cy="submit">Výpočet</Button>
				</div>

				{result && <Result childallowance={result} />}
				{result && (
					<div css={Row}>
						<Button onClick={reset} data-cy="reset">
							Nový výpočet
						</Button>
					</div>
				)}
				<Info css={Row}>
					<p>
						<sup>1</sup> Zadávejte průměrný měsíční příjem celé domácnosti za předchozí kalendářní
						čtvrtletí. Jako příjem se počítá mzda ze zaměstnání nebo příjmy z podnikání. Dále také
						nemocenská, rodičovský příspěvek, mateřská, podpora v nezaměstnanosti nebo třeba výživné
						(a další příjmy). Jako příjem se naopak nepočítá příspěvek na bydlení, porodné, dávky
						hmotné nouze, příspěvek na péči aj.
					</p>

					<p>
						<sup>2</sup> Zadávejte ANO, pokud má alespoň jedna společně posuzovaná osoba, v každém
						kalendářním měsíci, příjem ve výši nejméně 3860 Kč, dle §18, odstavec 2, zákon číslo
						117/1995. Tedy z výdělečné činnosti (zaměstnání, SVČ). Nebo nemocenské dávky, důchodové
						dávky, podpora v nezaměstnanosti či rekvalifikaci, příspěvek na péči o osobu do 18 roků,
						rodičovský příspěvek.
					</p>
				</Info>
			</Form>
		</Wrapper>
	);
};
